// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"0b8ff99e","914":"f0049b62"}[chunkId] + ".chunk.js";
};